import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "relative flex flex-col select-none w-84 p-8 space-y-6 focus:outline-none",
  tabindex: "0"
}
const _hoisted_2 = { class: "text-white text-2xl font-bold leading-tight text-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col items-center rounded-lg justify-center p-6 bg-danger-600 text-white space-y-4"
}
const _hoisted_4 = {
  key: 0,
  class: "text-center text-lg font-bold"
}
const _hoisted_5 = {
  key: 1,
  class: "text-center text-base font-medium leading-tight"
}
const _hoisted_6 = { class: "flex flex-col space-y-2" }


import BaseModal from './BaseModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmergencyModal',
  props: {
  title: {
    type: String,
    default: ''
  },
  message: {
    type: String,
    default: ''
  }
},
  emits: ["exit", "close"],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, { "bg-color": "danger-500" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('custom.uhb.emergency.message')), 1),
        (__props.title && __props.title.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (__props.title && __props.title.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.title), 1))
                : _createCommentVNode("", true),
              (__props.message && __props.message.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.message), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "bg-gray-900 hover:bg-gray-800 rounded-lg flex justify-center py-4 text-white text-base font-semibold",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('exit')))
          }, _toDisplayString(_ctx.$t('custom.uhb.emergency.confirm-exit')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "bg-danger-500 hover:bg-danger-600 rounded-lg flex justify-center py-4 opacity-50 text-white text-base font-semibold border border-white",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          }, _toDisplayString(_ctx.$t('custom.uhb.emergency.cancel-alert')), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})